import {
  AfterViewChecked,
  Component,
  ElementRef,
  Input,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RoleService } from '~/app/core/services';

@Component({
  selector: 'app-submenu',
  templateUrl: './submenu.component.html',
  styleUrls: ['./submenu.component.scss'],
})
export class SubmenuComponent implements AfterViewChecked {
  @Input() module;
  @Input() index: number;
  @ViewChild('itemLink') view: ElementRef<HTMLElement>;
  @ViewChild('submenu') submenu: ElementRef<HTMLElement>;

  isHover = false;

  constructor(
    private roleService: RoleService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngAfterViewChecked(): void {
    if (!this.isHover) return;
    const documentBot =
      document.documentElement.getBoundingClientRect().bottom - 50;
    const viewTop = this.view.nativeElement.getBoundingClientRect().top;
    const submenuBot =
      this.submenu.nativeElement.getBoundingClientRect().bottom;
    const submenuHeight =
      this.submenu.nativeElement.getBoundingClientRect().height;
    // stop functioning criteria
    // out of bound case
    if (submenuBot > documentBot || viewTop + submenuHeight > documentBot) {
      this.submenu.nativeElement.style.top = 'unset';
      this.submenu.nativeElement.style.bottom = '-10px';
      return;
    }
    this.submenu.nativeElement.style.top =
      this.view.nativeElement.getBoundingClientRect().top + 60 + 'px';
    this.submenu.nativeElement.style.bottom = 'unset';
  }

  onHover(yes: boolean) {
    this.isHover = yes;
  }

  onClick($event): void {
    $event.preventDefault();
    this.roleService.onNavToModule(
      this.module,
      this.activatedRoute.routeConfig.path,
      this.index
    );
  }

  onChildNavClick() {
    this.roleService.setActive(this.module, this.index);
  }

  onNavToDashBoard() {
    //Set inactive for before selected module
    const module = this.roleService.module.find((item) => item?.isActive);
    if (module) {
      module.isActive = false;
    }
  }
}
